export default "__VITE_ASSET__d1YDLM5o__"